<template>
  <section class="footer">
    <div class="copyright"><a href="https://ncovjp.com" target="_blank">nCoVJP.com</a></div>
    <div class="updated">{{ $t('message.last_updated') }}: {{ update.time }}</div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState({
      update: (state) => state.visions.update || {},
    }),
  },
}
</script>

<style lang="less" scoped>
.footer {
  padding: 36px 0 96px;
  text-align: center;
  font-size: 12px;
  line-height: 2em;
  color: #999;
  text-shadow: 0 -2px 0 #fff;
  background-color: hsl(0,0%,98%);
  position: relative;
  a {
    color: #999;
    text-decoration: none;
  }
}
</style>
